import { useRef, useEffect } from 'react';
import { useViewportSize } from '../useViewportSize/useViewportSize.esm.js';

var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
var useDisableExternalInputs = function(active) {
    var isMobileViewport = useViewportSize().isMobileViewport;
    var containerRef = useRef(null);
    useEffect(function() {
        if (!active || !containerRef.current || !isMobileViewport) return;
        var container = containerRef.current;
        var allElements = Array.from(document.querySelectorAll(focusableSelector));
        var focusableElements = Array.from(container.querySelectorAll(focusableSelector));
        var nonFocusableElements = allElements.filter(function(element) {
            var isDisabledElement = element.getAttribute("readonly") === "" || element.getAttribute("disabled") === "";
            return !isDisabledElement && !focusableElements.includes(element);
        });
        nonFocusableElements.forEach(function(element) {
            element.setAttribute("readonly", "readonly");
            element.setAttribute("disabled", "true");
            element.blur();
        });
        return function() {
            nonFocusableElements.forEach(function(element) {
                element.removeAttribute("readonly");
                element.removeAttribute("disabled");
            });
        };
    }, [
        isMobileViewport,
        active
    ]);
    return containerRef;
};

export { useDisableExternalInputs };
